import { Box } from '@chakra-ui/react';
import { ReactElement } from 'react';

import { ColorPaletteList } from '../ColorPalette';
import { PUBLIC_COLOR_PALETTES } from './ExploreTab.config';

interface ExploreTabProps {
  handleShuffleColors: (colors: string[]) => void;
}

export const ExploreTab = ({ handleShuffleColors }: ExploreTabProps): ReactElement => {
  return (
    <Box w='full' px={4}>
      <ColorPaletteList
        colorPaletteList={PUBLIC_COLOR_PALETTES}
        hasBrandKitPermission={true}
        onShuffle={handleShuffleColors}
      />
    </Box>
  );
};
